import { render, staticRenderFns } from "./LayoutApp.vue?vue&type=template&id=321f9e6c&scoped=true&"
import script from "./LayoutApp.vue?vue&type=script&lang=ts&"
export * from "./LayoutApp.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutApp.vue?vue&type=style&index=0&id=321f9e6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f9e6c",
  null
  
)

export default component.exports